module.exports = __webpack_public_path__ + "img/解决方案2@2x.e2ba157a.png";